module.exports = __webpack_public_path__ + "static/media/Loading.2dd616f4.gif";